import { render } from "./ProfileCardOne.vue?vue&type=template&id=4e29075b&scoped=true&ts=true"
import script from "./ProfileCardOne.vue?vue&type=script&lang=ts"
export * from "./ProfileCardOne.vue?vue&type=script&lang=ts"

import "./ProfileCardOne.vue?vue&type=style&index=0&id=4e29075b&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e29075b"]])

export default __exports__